import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import "./All_Time_Fav.css";
import Product_card from "../../common-components/product_card/Product_card";
import Green_round_btn from "../../common-components/common_btn/green_round_btn/Green_round_btn";
import { useNavigate } from "react-router-dom";
import Product_Info_Card from "../../common-components/product_info_card/Product_Info_Card";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import ScrollAnimation from "react-animate-on-scroll";
import { variant_type } from "../../../utils/common";

function All_Time_Fav({ products }) {
  const navigate = useNavigate();

  console.log("products", products);

  const handleToggle = () => {
    navigate("/categories");
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      disable: false,
      startEvent: "DOMContentLoaded",
      mirror: true,
      offset: 0,
    });
    AOS.refresh();
  }, []);

  // AOS.init({ disable: 'mobile' });

  return (
    <section className="All_Time_Fav">
      <div className="container-fluid">
        <h4 className="heading_text">All-Time Favs</h4>

        <div className="all_prods_holder">
          {products && products.length > 0 ? (
            <div className="row">
              {products.map((product, index) => {
                let metal;
                let size;
                let triple;
                if (
                  Number(product?.variant_type_id) ===
                  Number(variant_type.Single)
                ) {
                  metal = product?.Product_Variants?.[0];
                } else if (
                  Number(product?.variant_type_id) ===
                  Number(variant_type.Double)
                ) {
                  metal = product?.Product_Variants?.[0];
                  size = metal?.Double_Variants?.[0];
                } else if (
                  Number(product?.variant_type_id) ===
                  Number(variant_type.Triple)
                ) {
                  metal = product?.Product_Variants?.[0];
                  size = metal?.Double_Variants?.[0];
                  triple = size?.Triple_Variants?.[0];
                }

                const activeVariant = triple || size || metal;

                return (
                  <div
                    className="col-lg-3 col-md-4 col-6  p-1"
                    key={product?.id || index}
                  >
                    <ScrollAnimation animateIn="zoomIn">
                      <div className="product_card_holder">
                        <Product_Info_Card
                          product={product}
                          id={product?.id}
                          imgSrc={
                            process.env.REACT_APP_IMG_URL + product?.image
                          }
                          vdoSrc={
                            process.env.REACT_APP_IMG_URL + product?.video
                          }
                          productName={product?.name}
                          priceText={activeVariant?.price || 0}
                          mrp={activeVariant?.mrp || 0}
                          kgText={metal?.Metal?.name}
                          savingPrice={
                            parseFloat(activeVariant?.mrp || 0) -
                            parseFloat(activeVariant?.price || 0)
                          }
                        />
                      </div>
                    </ScrollAnimation>
                  </div>
                );
              })}

              {products.length > 3 && (
                <div className="text-center mt-4 d-flex justify-content-center">
                  <Green_btn btnText="View all" onClick={handleToggle} />
                </div>
              )}
            </div>
          ) : (
            <div className="no_product_available_holder text-center w-100">
              <h3>No Product Added In All-Time Favs</h3>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default All_Time_Fav;
